import { scaleValue } from "../theme"

export const xsScaleFactor = 1
export const mdScaleFactor = 0.8
export const lgScaleFactor = 0.8
export const xlScaleFactor = 0.9

export const pageWidth = {
    xs: {
        width: "100%",
        maxWidth: 1296,
        paddingLeft: 16,
        paddingRight: 16,
        scrollPaddingLeft: 16,
        scrollPaddingRight: 16,
    },
    md: {
        paddingLeft: 24,
        paddingRight: 24,
        scrollPaddingLeft: 24,
        scrollPaddingRight: 24,
    },
} as const

export const pageSize = {
    xs: { ...pageWidth.xs, paddingBottom: 16 },
    md: { ...pageWidth.md, paddingBottom: 24 },
} as const

export type FixedSpacingSize = "xs" | "sm" | "md" | "lg" | "xl"

export const fixedSpacingSizes = {
    xs: 8,
    sm: 16,
    md: 24,
    lg: 32,
    xl: 40,
} as const

export const sectionSpacing = {
    xs: scaleValue(36),
    md: scaleValue(48),
}
